import axios from 'axios'
import { hex_md5 } from 'react-native-md5'
const api = axios.create({
    baseURL: '/memberapi',
    //baseURL: 'http://localhost/sales',
})

const setHeader = (k, v) => {
    api.defaults.headers.post[k] = v
    api.defaults.headers.get[k] = v
    api.defaults.headers.put[k] = v
    api.defaults.headers.delete[k] = v
}

const signIn = (userInfo, headers) => api.post(`/user/login`, userInfo, headers)
const signOut = (headers)=>api.get(`/user/signout`,headers)
const signUp = (userInfo, headers) => api.post(`/user/register`, userInfo, headers)
const sendCode = (data,headers) =>api.post(`/user/sendcode`,data,headers)
const sendCode1 = (data,headers) =>api.post(`/user/sendcode1`,data,headers)
const resetPwd = (data,headers) => api.post(`/user/resetpwd`,data,headers)
const emailVerify = (data,headers) => api.post(`/user/verifycode`,data,headers)
const loadUseProfile = (headers)=>api.get(`/user/profile`,headers)
const modifyUserProfile = (data,headers)=>api.post(`/user/profile`,data,headers)

const apis = {
    signIn,
    signOut,
    signUp,
    resetPwd,
    sendCode,sendCode1,
    emailVerify,
    loadUseProfile,
    setHeader,
    modifyUserProfile,
    //member
    loadKidsProfile:(headers)=>api.get(`/member/loadmembers`,headers),
    editKidProfile:(data,headers)=>api.post(`/member/editmember`,data,headers),
    loadTransactions:(page,pagesize,countdata,bid,headers)=>api.get(`/member/loadtransactions?bid=`+bid+`&page=`+page+'&pagesize='+pagesize+'&countdata='+countdata+`&time=`+Date.now(),headers),
    loadBalance:(headers)=>api.get(`/member/loadbalance`,headers),
    loadSchedule:(from,headers)=>api.get('/member/loadschedule?from='+from,headers),
    loadSchedules:(from,headers)=>api.get('/member/loadschedules?from='+from,headers),
    setupRecharge:(data,headers)=>api.post("/member/setuppay",data,headers),
    //event    
    getRaces:(headers)=>api.get('/event/getraces',headers),
    getEvent:(code,applyid,token,time,headers)=>api.get( `/event/getevent?code=`+code+(applyid>0?(`&applyid=`+applyid+`&token=`+token+`&time=`+time):''),headers),
    applyEvent:(data,headers)=>api.post(`/event/applyevent`,data,headers),
    payEvent:(data,headers)=>api.post(`/event/payevent`,data,headers),
    loadEvents:(headers)=>api.get('/event/loadevents',headers),
    loadApplicants:(code,headers)=>api.get('/event/loadapplicants?code='+code,headers),
    //home
    loadResources:(type,resourcetype,page,pagesize,countdata,headers) => api.get(`/home/loadresources?type=`+type+`&resource_type=`+resourcetype+`&page=`+page+'&pagesize='+pagesize+'&countdata='+countdata+`&time=`+Date.now(),headers),
    //pay
    setupPay:(id,code,headers)=>api.post('/event/setuppay',{id:id,code:code},headers),

    //items
    loadItems:(headers)=>api.get('/item/items'),
    loadRentals:(headers)=>api.get('/item/rentals')
}

export default apis
